'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('../_tslib-bcbe0269.js');

var core = require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);

var IconStar = React__default.forwardRef(function (_a, ref) {
  var _b = _a.weight,
      weight = _b === void 0 ? "normal" : _b,
      props = _tslib.__rest(_a, ["weight"]);

  return core.jsx("svg", _tslib.__assign({
    viewBox: "0 0 24 24",
    ref: ref,
    css: core.css(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "], ["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "])))
  }, props), core.jsx("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M12.729 1.2l3.346 6.629 6.44.638a.806.806 0 0 1 .5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 0 1-1.151.935L12 19.934l-6.52 3.229a.813.813 0 0 1-1.151-.935l1.965-7.138L.99 9.837a.804.804 0 0 1 .5-1.374l6.44-.638L11.271 1.2a.819.819 0 0 1 1.458 0z"
  }));
});
var templateObject_1;
exports.IconStar = IconStar;